import {RoomImage} from '@findhotel/sapi'

/**
 * Sorts and groups top room images by caption config.
 * Default first top images: Room: 2, Bathroom: 1
 * @param roomImages - Room images to sort and group
 * @returns Sorted room images
 */
export const sortTopRoomImagesByCaption = (roomImages: RoomImage[]) => {
  const head = []
  const tail = []

  const config: Record<string, number> = {Room: 2, Bathroom: 1}
  const sortOrder = ['Room', 'Bathroom']

  for (const image of roomImages) {
    const imageCaption = image.caption || ''
    //extract priority images into head part
    if (config[imageCaption] > 0) {
      head.push(image)
      config[imageCaption]--
    } else {
      //extract other images into tail part
      tail.push(image)
    }
  }

  return [
    //sort head part by caption
    ...head.sort(
      (a, b) =>
        sortOrder.indexOf(a.caption || '') - sortOrder.indexOf(b.caption || '')
    ),
    ...tail
  ]
}
